module.exports = __webpack_public_path__ + "img/tarot-major-arcana-16.427efa68.png";